const MetronomeErrorCode = {
  METRONOME_UNAVAILABLE: "METRONOME_UNAVAILABLE",
  NOT_FOUND: "NOT_FOUND"
};
const MetronomeResourceType = {
  CUSTOMER: "customer",
  CONTRACT: "contract",
  INVOICE: "invoice"
};
function resolvePeriodCreditCapacity(period) {
  return period.balances.kind === "live" ? period.credits_used - period.credits_overage + period.balances.remaining_credits : null;
}
export {
  MetronomeErrorCode,
  MetronomeResourceType,
  resolvePeriodCreditCapacity
};
//# sourceMappingURL=metronome.js.map
